// good article how to use mixins
// https://css-tricks.com/how-the-vue-composition-api-replaces-vue-mixins/

import Vue from "vue";

export default function () {
  /**
   * Display and report errors
   *
   * @param {string} title
   * @param {string} text
   * @param {*} err
   */
  function alertErrorAndReport(err, title = "Erreur", html = "") {
    Vue.swal({
      icon: "error",
      title: title,
      html: html,
      showConfirmButton: true,
      confirmButtonText: "Signaler cette erreur",
      confirmButtonClass: "btn btn-primary btn-lg",
    }).then(res => {
      if (res.value) {
        // TODO: Send the error to DEV team by email
        console.log("Send the error to DEV team", err);
      }
    });
  }

  return {
    alertErrorAndReport,
  };
}
